import React from 'react';
import { Redirect } from 'react-router-dom';

/**
 * Catch-all for unmatched URLs — most visibly the root module menu items
 * (Admissions, Registration, ...) whose sidebar entries navigate to a bare
 * module path (e.g. /admissions) that has no landing page. Instead of the old
 * blank Dashboard placeholder, land on Home — which hosts the full-page
 * embedded Aristotle assistant when the aristotle_assistant_home flag is on,
 * and the legacy (empty) Dashboard when it is off.
 *
 * Redirect (replace) rather than rendering in place, so the embed has ONE
 * canonical URL (/home): the floating launcher hides itself there, and the
 * Home menu item / header logo highlight correctly.
 */
const AssistantCatchAll = () => <Redirect to="/home" />;

export default AssistantCatchAll;
